module.exports = __webpack_public_path__ + "img/head.b1ae537f.png";